/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Ui_HInputs */

const en_wc_tut_ui_h = /** @type {(inputs: Wc_Tut_Ui_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2. Find your way around the ribbon`)
};

/**
* | output |
* | --- |
* | "2. Find your way around the ribbon" |
*
* @param {Wc_Tut_Ui_HInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_ui_h = /** @type {((inputs?: Wc_Tut_Ui_HInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Ui_HInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_ui_h(inputs)
});
export { wc_tut_ui_h as "wc.tut.ui.h" }